import PropTypes from 'prop-types';
import { useState, useMemo } from 'react';
import FeatherIcon from 'feather-icons-react';
import { Button, Col, Radio, Row } from 'antd';
import { useAssetsByFinalCustomer } from './hooks/useAssetsByFinalCustomer';
import { AssetRadioGroup } from '../finalCustomers/FinalCustomerInput/styles/styles';
import { ModalAddAssetToFinalCustomer } from '../finalCustomers/ModalAddAssetToFinalCustomer/ModalAddAssetToFinalCustomer';
import { AssetsService } from '../../services/assetsService';
import { useCanEditAsset } from '../../hooks/useCanEditAsset';

export const AssetsByFinalCustomerButtons = ({
  assetTypeId,
  finalCustomerId,
  finalCustomerAssetTypeData,
  onChange,
  selectedAssetValue,
  getData,
  createAsset,
  updateAsset,
  localAsset,
}) => {
  const [isOpenCreateAssetModal, setIsOpenCreateAssetModal] = useState(false);
  const canEditAssets = useCanEditAsset();
  const { assets, reloadAssets } = useAssetsByFinalCustomer({ assetTypeId, idFinalCustomer: finalCustomerId, getData });
  const assetsList = useMemo(() => {
    const items = Array.isArray(assets?.assets) ? [...assets.assets] : [];
    if (localAsset) {
      items.unshift(localAsset);
    }
    return items;
  }, [localAsset, assets]);

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  const handleCloseCreateAssetModal = () => {
    setIsOpenCreateAssetModal(false);
    reloadAssets();
  };

  const openCreateAssetModal = () => {
    setIsOpenCreateAssetModal(true);
  };

  return (
    <>
      <Row gutter={8}>
        {assetsList.map((asset) => {
          return (
            <Col xs={10} md={7} lg={7} xl={6}>
              <AssetRadioGroup value={selectedAssetValue} onChange={handleChange}>
                <Radio className="styledRadio" value={asset._id}>
                  <b>{asset.name}</b>
                </Radio>
              </AssetRadioGroup>
            </Col>
          );
        })}
        {canEditAssets ? (
          <Col xs={4} md={2} lg={2} xl={2} style={{ display: 'flex' }}>
            <Button
              style={{
                width: '100%',
                height: '85%',
                minHeight: '45px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onClick={openCreateAssetModal}
              type="default"
              icon={<FeatherIcon icon="plus" />}
            />
            <></>
          </Col>
        ) : null}
      </Row>
      <ModalAddAssetToFinalCustomer
        show={isOpenCreateAssetModal}
        handleClose={handleCloseCreateAssetModal}
        assetTypeData={finalCustomerAssetTypeData}
        finalCustomerId={finalCustomerId}
        createAsset={createAsset}
        updateAsset={updateAsset}
      />
    </>
  );
};

AssetsByFinalCustomerButtons.propTypes = {
  assetTypeId: PropTypes.string,
  finalCustomerId: PropTypes.string,
  finalCustomerAssetTypeData: PropTypes.object,
  onChange: PropTypes.func,
  selectedAssetValue: PropTypes.string,
  getData: PropTypes.func,
  createAsset: PropTypes.func,
  updateAsset: PropTypes.func,
  localAsset: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
  }),
};

AssetsByFinalCustomerButtons.defaultProps = {
  getData: AssetsService.getAssetsByType,
};
